import { render, staticRenderFns } from "./PapercleanConfigurazioneMarcheListComponent.vue?vue&type=template&id=244de9ac"
import script from "./PapercleanConfigurazioneMarcheListComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneMarcheListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports